import FeeScheduleCategoryCommand from "marketplace/teams/fee-schedules/_api/commands/fee-schedule-category-command";
import FeeScheduleTemplate from "work/fee-schedule-templates/fee-schedule-template";

export default class FeeScheduleTemplateCommand {
  public entityId: string;
  public name: string;
  public tags: string[] = [];
  public categories: FeeScheduleCategoryCommand[] = [];
  public creatorType?: string;

  constructor(template: FeeScheduleTemplate, creatorType: string = 'client') {
    if (!template.creator?.legalEntityId) {
      throw new Error(
        "Template must indicate entity fee schedule is being created for."
      );
    }
    this.entityId = template.creator.legalEntityId.value;
    this.name = template.name;
    this.tags = template.tags.map((tag) => tag.value);
    this.categories = template.categories.map(
      (category) => new FeeScheduleCategoryCommand(category)
    );
    this.creatorType = creatorType;
  }

  public get payload() {
    return {
      entityId: this.entityId,
      name: this.name,
      tags: this.tags,
      categories: this.categories,
      creatorType: this.creatorType
    }
  }
}
